import React, { FC } from 'react';

import { getClassNames } from './VerticalAlign.styles';
import { VerticalAlignProps } from './VerticalAlign.types';

export type { VerticalAlignProps };

/**
 * VerticalAlign uses flexbox styling to align child items vertically.
 */
const VerticalAlign: FC<VerticalAlignProps> = ({
  align = 'center',
  horizontalAlign = 'left',
  height = '100%',
  className,
  children,
}) => {
  const { inner, verticalAlign } = getClassNames(align, horizontalAlign, height, className);

  return (
    <div className={verticalAlign}>
      <div className={inner}>{children}</div>
    </div>
  );
};

export default VerticalAlign;
